import { z } from 'zod'

export const blackoutLevelSchema = z.enum(['head', 'director', 'exec_director'])
export type BlackoutLevel = z.infer<typeof blackoutLevelSchema>

export const blackoutSchema = z.object({
  id: z.guid(),
  name: z.string(),
  startDate: z.string().date(),
  endDate: z.string().date(),
  teamIds: z.array(z.guid()),
  level: blackoutLevelSchema,
  note: z.string().nullable().optional(),
  createdAt: z.string().datetime(),
})

export type Blackout = z.infer<typeof blackoutSchema>

export const blackoutCreateSchema = blackoutSchema
  .omit({ id: true, createdAt: true })
  .refine((d) => d.startDate <= d.endDate, {
    message: 'startDate must be on or before endDate',
    path: ['endDate'],
  })

export type BlackoutCreate = z.infer<typeof blackoutCreateSchema>

/** PATCH body — every field optional. Omitted = unchanged. */
export const blackoutUpdateSchema = blackoutSchema
  .omit({ id: true, createdAt: true })
  .partial()

export type BlackoutUpdate = z.infer<typeof blackoutUpdateSchema>
